import TimePicker from "react-time-picker";


function TimeSelector({ time, onChange }) {

  return (
    <TimePicker className="time-picker" onChange={onChange} value={time} disableClock={true} />
  );
}

export default TimeSelector;